/**
 * SubjectViewModal - Модальное окно просмотра предмета
 */
import React from 'react';
import {
  Modal,
  Text,
  Group,
  Stack,
  Badge,
  Button,
  Divider,
  Box,
} from '@mantine/core';
import { IconPencil, IconBook } from '@tabler/icons-react';
import tokens from '../../theme/designTokens';

/**
 * Форматирование даты
 */
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Moscow',
  });
};

const SubjectViewModal = ({ opened, onClose, subject, onEdit }) => {
  if (!subject) return null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="xs">
          <IconBook size={20} color={tokens.colors.brand.primary} />
          <Text fw={600}>Предмет</Text>
        </Group>
      }
      centered
      radius="lg"
      size="md"
    >
      <Stack gap="md">
        {/* Статус */}
        <Group>
          {subject.is_active ? (
            <Badge color="green" variant="light" radius="xl" size="lg">
              Активен
            </Badge>
          ) : (
            <Badge color="gray" variant="light" radius="xl" size="lg">
              Неактивен
            </Badge>
          )}
        </Group>

        {/* Название */}
        <Box>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600} mb={4}>
            Название
          </Text>
          <Text size="lg" fw={500}>
            {subject.name}
          </Text>
        </Box>

        {/* Описание */}
        {subject.description && (
          <Box>
            <Text size="xs" c="dimmed" tt="uppercase" fw={600} mb={4}>
              Описание
            </Text>
            <Text size="sm" style={{ whiteSpace: 'pre-wrap' }}>
              {subject.description}
            </Text>
          </Box>
        )}

        <Divider />

        {/* Метаданные */}
        <Group justify="space-between">
          <Box>
            <Text size="xs" c="dimmed">Создан</Text>
            <Text size="sm">{formatDate(subject.created_at)}</Text>
          </Box>
          {subject.created_by_name && (
            <Box>
              <Text size="xs" c="dimmed">Автор</Text>
              <Text size="sm">{subject.created_by_name}</Text>
            </Box>
          )}
        </Group>

        {subject.updated_at !== subject.created_at && (
          <Box>
            <Text size="xs" c="dimmed">Обновлён</Text>
            <Text size="sm">{formatDate(subject.updated_at)}</Text>
          </Box>
        )}

        {/* Кнопки */}
        <Group justify="flex-end" gap="sm" mt="md">
          <Button variant="subtle" color="gray" onClick={onClose}>
            Закрыть
          </Button>
          <Button
            leftSection={<IconPencil size={16} />}
            onClick={() => onEdit(subject)}
          >
            Редактировать
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default SubjectViewModal;
